// extracted by mini-css-extract-plugin
export default {"card__header":"cardHeader_card__header__XPOs4"};